<div class="feSearchBar" [class.thinSearchBar]="thinSearchBar">
    <mat-icon class="greyC">search</mat-icon>
    <input placeholder="{{placeHolder}}" [formControl]="control" (input)="change()" [value]="value">
    <mat-icon class="cleanSearchBarIcon" (click)="clear()">close</mat-icon>
</div>
